import { generateOrderGrooveAuthSignature } from './generateOrderGrooveAuthSignature';

export const generateOrderGrooveAuthHeader = async (
    userId: string,
    merchantId: string | undefined
) => {
    const { timestamp, signature } =
        await generateOrderGrooveAuthSignature(userId);

    return JSON.stringify({
        public_id: merchantId,
        sig_field: userId,
        timestamp,
        signature,
        trust_level: 'recognized',
    });
};
